const TRANSLATIONS_EN = {
    servicePhotosFieldLabel: 'Photos'
};

export default TRANSLATIONS_EN;
